module.exports = __webpack_public_path__ + "img/details.ef4ede2a.svg";